import { render, staticRenderFns } from "./success-orders.vue?vue&type=template&id=5b0c4886&"
import script from "./success-orders.vue?vue&type=script&lang=js&"
export * from "./success-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports